module.exports = __webpack_public_path__ + "img/3S.954750a9.png";